// export const isMobile = () => /Mobi|Android/i.test(window.navigator.userAgent)
import UAParser from "ua-parser-js"
import { LANG_OPTIONS } from "@/utils/options"
export const isMobile = () => {
  const parser = new UAParser()
  const device = parser.getDevice()
  return device.type === "mobile" || device.type === "tablet"
}

export const getWindowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
  isLarge: window.innerWidth > 768
})

export const debounce = (fn, delay = 300) => {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

export const getNavLanguage = () => {
  const langOptions = [...LANG_OPTIONS]
  const lang = navigator.language || navigator.browserLanguage
  return langOptions.find(x => x.value === lang.split("-")[0].toLowerCase())?.value || langOptions[0].value
}



// WEBPACK FOOTER //
// ./src/utils/deviceDetect.js